import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const receiptGroup = createSlice({
	name: "receiptGroup",
	initialState: {
		loading: false,
		error: null,
		filter: {
			page: 1,
			limit: DATA_LIMIT
		},
		items: [],
		pagination: {
			page: 1,
			limit: DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})

export const receiptGroupActions = receiptGroup.actions;
export const receiptGroupReducer = receiptGroup.reducer;
export const receiptGroupItemsSelector = (state) => state.receiptGroup.items;
export const receiptGroupLoadingSelector = (state) => state.receiptGroup.loading;
export const receiptGroupErrorSelector = (state) => state.receiptGroup.error;
export const receiptGroupFilterSelector = (state) => state.receiptGroup.filter;
export const receiptGroupPaginationSelector = (state) => state.receiptGroup.pagination;

